import { TournamentSegmentGroupBase } from "model/Tournament/Segment/TournamentSegmentGroup";
import { FsTournamentSegmentGroupBase } from "db/model/tournament/Segment/FsTournamentSegmentGroup";

export const mapTournamentSegmentGroupBase = (
  fsModel: FsTournamentSegmentGroupBase
): TournamentSegmentGroupBase => {
  return {
    groupId: fsModel.groupId,
    name: fsModel.name,
  };
};
